import { pathRedirect } from '@/utils/auth'

import Config from '@/containers/System/Config'
import Role from '@/containers/System/Role'
import Account from '@/containers/System/Account'
// import Dictionary from '@/containers/System/Dictionary'
import Menu from '@/containers/System/Menu'
import Organization from '@/containers/System/Organization'
import Log from '@/containers/System/Log'
import Test from '@/containers/System/Test'
import ChargeSetting from '@/containers/System/ChargeSetting'
import Manufacturer from '@/containers/System/Manufacturer'
import SystemSetting from '@/containers/System/SystemSetting'
import InitData from '@/containers/System/InitData'
import shouquanma from '@/containers/System/shouquanma'
import Welcome from '@/containers/System/Welcome'

// import { getApi } from '@/containers/system/getApi'

export default {
  path: 'system',
  redirect: pathRedirect,
  children: [
    { path: 'config', component: Config },
    { path: 'role', component: Role },
    { path: 'account', component: Account },
    { path: 'menu', component: Menu },
    { path: 'organization', component: Organization },
    { path: 'log', component: Log },
    { path: 'chargeSetting', component: ChargeSetting },
    { path: 'manufacturer', component: Manufacturer },
    { path: 'systemSetting', component: SystemSetting },
    { path: 'initData', component: InitData },
    { path: 'test', component: Test },
    { path: 'welcome', component: Welcome },
    { path: 'shouquanma', component: shouquanma }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/system.js